import React from "react";
import { Select } from "antd";
import { useQuery } from "react-query";

import { LookUpApiService } from "../../../ApiServices";
import { API_STORAGE_KEY } from "../../../constants/constant";
import notificationService from "../../../util/notification.service";

const getGeneralTag = async () => {
  const { ok, data, response } = await LookUpApiService.getGeneralTag();
  if (ok) {
    return data;
  } else {
    notificationService.error(response.message);
    throw new Error(response.message);
  }
};

const ActivityTagLookup = (props) => {
  const { data: generalTag = [], isLoading } = useQuery(
    API_STORAGE_KEY.GENERAL_TAG_LOOKUP,
    getGeneralTag,
  );

  return (
    <>
      <Select
        mode={props?.isSingleSelect ? "" : "multiple"}
        disabled={isLoading}
        loading={isLoading}
        showSearch
        filterOption={(input, option) => {
          return option.props.children
            .toLowerCase()
            .includes(input.toLowerCase());
        }}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        {...props}
      >
        {generalTag?.map((data, index) => {
          return (
            <Select.Option key={data?.id} value={data.id}>
              {data.name}
            </Select.Option>
          );
        })}
      </Select>
    </>
  );
};
export default ActivityTagLookup;
